import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {fromEvent, Subject} from 'rxjs';
import {SubSink} from '@Common/core/utils/subsink';
import {filter, finalize, switchMapTo, take} from 'rxjs/operators';
import {UrlService} from '../../../../common/services/url/url.service';
import {FormulaireService} from '../../../../common/services/formulaire/formulaire.service';
import {FormModel} from '../../../../common/components/form/models';
import {UrlModel} from '../../../../common/services/url/url.model';

@Component({
  selector: 'app-edit-slug-in-place',
  templateUrl: './edit-slug-in-place.component.html',
  styleUrls: ['./edit-slug-in-place.component.scss']
})
export class EditSlugInPlaceComponent implements OnInit, OnDestroy {
  @Input() form: FormModel;
  @Output() slugSend: EventEmitter<UrlModel> = new EventEmitter<UrlModel>();
  /**
   * Est-il en train d'éditer le raccourci lien ?
   */
  @Output() editInPlace: EventEmitter<boolean> = new EventEmitter<boolean>();
  MAX_LENGTH = 80;
  column: string;
  data: any;
  onEdit = false;
  model: string;
  searching = false;
  editMode = new Subject();
  editMode$ = this.editMode.asObservable();
  subSink = new SubSink();
  constructor(private host: ElementRef,
              private toastySvc: SnackBarToastyService,
              private urlSvc: UrlService,
              public formSvc: FormulaireService) { }
  get formName() {
    return this.form.nom;
  }
  get slug() {
    return this.form?.url_obj[0]?.slug;
  }
  ngOnInit(): void {
    this.model = this.formName;
    /** edit dblClick https://netbasal.com/keeping-it-simple-implementing-edit-in-place-in-angular-4fd92c4dfc70 */
    this.viewModeHandler();
    this.editModeHandler();
  }
  save() {
    this.searching = true;
    if (this.form) {
      this.urlSvc
        .slugProposal(this.form.uuid, this.model)
        .pipe(finalize(() => this.searching = false))
        .subscribe(_url => {
          if (_url['exist']) {
            this.toastySvc.toasty(
              'Raccourci lien',
              `ce raccourci de lien existe déjà pour un autre formulaire, veuillez en choisir un autre<br/>raccourci : ${_url['slug']}`,
              typeToast.error);
          } else {
            this.slugSend.emit(_url['url']);
            this.onEdit = false;
            this.editInPlace.emit(this.onEdit);
          }
        });
    }
  }
  goEdit() {
    this.model = this.formName;
    this.onEdit = true;
    this.editInPlace.emit(this.onEdit);
  }
  cancel() {
    this.onEdit = false;
    this.editInPlace.emit(this.onEdit);
  }
  @HostListener('keyup.enter')
  onEnter() {
    if (this.model) {
      this.save();
    }
  }
  private get element() {
    return this.host.nativeElement;
  }
  private viewModeHandler() {
    this.subSink.sink = fromEvent(this.element, 'dblclick')
      .subscribe(() => {
        this.onEdit = true;
        this.editMode.next(true);
      });
  }
  private editModeHandler() {
    const clickOutside$ = fromEvent(document, 'click').pipe(
      filter(({ target }) => this.element.contains(target) === false),
      take(1)
    );
    this.subSink.sink = this.editMode$.pipe(
      switchMapTo(clickOutside$),
    ).subscribe(event => {
      this.onEdit = false;
      this.editInPlace.emit(this.onEdit);
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
